import { makeAutoObservable, toJS } from 'mobx'

import { findExcursionsStore } from '../find-excursions/find-excursions-store'
import { IFindExcursions, ISearchDirection } from '../find-excursions/models'
import { listExcursionStore } from '../list-excursions/list-excursions-state'

const initialState: IFindExcursions = {
  departure_date: '',
}

class CopyFindExcursionsStore {
  findExcursions: IFindExcursions = initialState

  constructor() {
    makeAutoObservable(this)
  }

  resetFindCopy() {
    this.findExcursions = initialState
  }

  onSelectDirection(direction: ISearchDirection) {
    this.findExcursions = {
      ...this.findExcursions,
      direction: direction.direction_name || '',
      name: direction.name || '',
    }
  }

  onChangeDepartureDate(date: string) {
    this.findExcursions.departure_date = date
  }

  onSetDataCopy() {
    this.findExcursions = toJS(findExcursionsStore.findExcursions)
  }

  setCopyForSearch() {
    findExcursionsStore.findExcursions = {
      ...findExcursionsStore.findExcursions,
      ...toJS(this.findExcursions),
    }
    listExcursionStore.resetList()
    const { filter, ...rest } = findExcursionsStore.findExcursions
    listExcursionStore.page = 1
    listExcursionStore.onGetExcursions({ ...filter, ...rest })
  }

  resetDays() {
    this.findExcursions = { ...this.findExcursions, departure_date: '' }
  }
}

export const copyFindExcursionsStore = new CopyFindExcursionsStore()
